import React from "react";

const RightCalendarIcon = ({
  size = "20",
  color = "var(--sidebar-active-color)"
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 20 20" fill="none">
      <path d="M7.49988 5.00012L12.4999 10.0001L7.49988 15.0001" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default RightCalendarIcon;
